import { render, staticRenderFns } from "./QuestionSection.vue?vue&type=template&id=7dea789c&scoped=true"
import script from "./QuestionSection.vue?vue&type=script&lang=js"
export * from "./QuestionSection.vue?vue&type=script&lang=js"
import style0 from "./QuestionSection.vue?vue&type=style&index=0&id=7dea789c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dea789c",
  null
  
)

export default component.exports